import styled from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'
import Section from './StyledSection'

const SearchResults = styled(Section).attrs({ pt: 'none', as: 'div' })`
  font-weight: normal;
  line-height: 1.4;
  color: var(--color-extra);
`

SearchResults.Total = styled.div`
  padding: 24px 0;
  font-size: 14px;
`

SearchResults.Empty = styled.div`
  padding-top: 100px;
  font-size: 20px;
  text-align: center;

  ${maxWidth(vars.breakpoints.tablet)`
    padding-top: 50px;
    font-size: 18px;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    padding-top: 30px;
    font-size: 16px;
  `}
`

SearchResults.List = styled.div`
  &:not(:last-child) {
    margin-bottom: 40px;
  }

  ${maxWidth(vars.breakpoints.mobile)`
    width: calc(100% + ${vars.container.spaceMobile}px * 2);
    margin-left: -${vars.container.spaceMobile}px;
  `}
`

SearchResults.LoadBtn = styled.div`
  text-align: center;
`

export default SearchResults
